import { createFileRoute, useRouter } from '@tanstack/react-router';
import { PaymentScheduleFormPage } from '@/components/organisms/payment-schedules/PaymentScheduleFormPage';

export const Route = createFileRoute('/_dashboard/dashboard/estimates/$id/payment-schedule')({
  component: EstimatePaymentSchedulePage,
});

function EstimatePaymentSchedulePage() {
  const { id } = Route.useParams();
  const router = useRouter();

  return (
    <PaymentScheduleFormPage
      entity={{ type: 'estimate', id }}
      showCustomerSummary
      showPresets
      onDone={() =>
        void router.navigate({
          to: '/dashboard/estimates/$id',
          params: { id },
          search: { tab: 'financials' } as never,
        })
      }
    />
  );
}
